import { Component, Input, OnInit, OnChanges, ChangeDetectionStrategy } from '@angular/core';
import { DataFieldComponentBase } from './datafield-base-component';
import { DataField } from './models/datafield';

import { LoadingPanelService, LoadingPanelSettings } from '../loading-panel/loading-panel.service';
import { GenericModalService, ModalSettingsInput, ModalMultiButton, ModalSettingsMessage, ModalSelectElement, SelectMultiChoiceTypes } from '../generic-modal/generic-modal.service';

import { DeveloperArtifactService } from '../../developer/services/developer-artifact.service';
import { DeveloperArtifactAssemblyPickerComponent } from '../../developer/developer-artifacts/developer-artifact-assembly-picker.component';


@Component({
    selector: 'ep-datafield-artifact-assembly-picker',
    templateUrl: './datafield-artifact-assembly-picker.component.html',
    inputs: ['isAlwaysEditable', 'datafield', 'formValidationGroup'],
    outputs: ['valueChanged'] // It's necessary to set this, because the valueChanged method is placed in the base-class and not inherited if this is not set.
    ,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [DeveloperArtifactAssemblyPickerComponent]
})

export class DataFieldArtifactAssemblyPickerComponent extends DataFieldComponentBase implements OnInit, OnChanges {

    constructor(private artifactService: DeveloperArtifactService, private loadingPanelService: LoadingPanelService, private modalService: GenericModalService) {
        super();
    }

    override ngOnInit() {
    }

    override ngOnChanges(changes: any) {
    }

    setValue(artifactId) {
        this.datafield.Value = artifactId;
        this.formValidationGroup.controls[this.validationIdentifier].updateValueAndValidity();
        this.notifyValueChanged(this.datafield);
    }

    get isValid() {
        if ((this.formValidationGroup.disabled) || this.formValidationGroup.controls[this.validationIdentifier].disabled) {
            return true;
        }

        return this.formValidationGroup.controls[this.validationIdentifier].valid == true;
    }
}
